import React__default from 'react';

/**
 * Unfortunately, TS < 4.7 does not support "instantiation expressions":
 * @see https://github.com/microsoft/TypeScript/pull/47607
 *
 * This means we cannot inter the return type of the generic `useCollection`
 * hook. Instead, a wrapper hook with the intended type was created to then
 * grab the return type from.
 *
 * TODO: once we upgrade our TS version, `registerOption` below can be updated
 * to: `ReturnType<typeof useCollection<OptionData>>["registerItem"]`
 */

const ListboxContext = /*#__PURE__*/React__default.createContext({});
const ListboxProvider = ListboxContext.Provider;
const useListboxContext = () => React__default.useContext(ListboxContext);

export { ListboxProvider, useListboxContext };
